module.exports = __webpack_public_path__ + "static/media/nuvemshop9.b7fc45b5.png";